import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersListagemAquisicoes,
  valoresExibidosOffCanvasListagemAquisicoes,
} from './auxiliarListagemAquisicoes';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { getAllAquisicoes } from '../../../../services/aquisicoes/listagemAquisicoesService';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import theme from '../../../../theme';
import { useExcelExport } from '../../../../utils/excel-export';
import { formatDateToFile } from '../../../../utils/functions';
import {
  getComponenteAfColor,
  getStatusColors,
  getTipoItemColor,
} from '../../../../utils/styleUtils';
import { SubAbas as subAbas } from '../subabas';

const ListagemAquisicoesIndex: React.FC = () => {
  const navigate = useNavigate();
  const user = getUser();
  const userID = user.sub;
  //PERMISSOES
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();

  // Dados do módulo
  const { getSelectDominioPai } = useSelect();
  const componenteAFoptions = getSelectDominioPai(1);
  const statusProaqOptions = getSelectDominioPai(52);
  const modalidadeAquisicaoOptions = getSelectDominioPai(133);
  const submodalidadeDispensaOptions = getSelectDominioPai(137);
  const submodalidadePregaoOptions = getSelectDominioPai(139);
  const tipoItemAquisitivoOptions = getSelectDominioPai(142);

  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Empenhos')?.value ||
      '0',
  );
  // Verificar permissões para ações

  const { exportData, isExporting } = useExcelExport('listagemaquisicoes');

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    tipo: '',
    status: '',
    componenteAf: 0,
    produtos: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllAquisicoes();

      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tiposAquisicaoUnicos = [
    { value: '', label: 'Todos' },
    ...Array.from(new Set(data.map((item) => item.tipo))).map((tipo) => ({
      value: tipo,
      label: tipo,
    })),
  ];

  const statusUnicos = [
    { value: '', label: 'Todos' },
    ...Array.from(new Set(data.map((item) => item.status))).map((status) => ({
      value: status,
      label: status,
    })),
  ];

  const dadosFiltrados = data.filter((item) => {
    const filtroTipo = formFiltros.tipo ? item.tipo === formFiltros.tipo : true;
    const filtroStatus = formFiltros.status
      ? item.status === formFiltros.status
      : true;
    const filtroComponente =
      formFiltros.componenteAf !== 0
        ? item.componenteAf ===
            componenteAFoptions.find(
              (componente) => componente.value == item.componenteAF,
            )?.label || 'Não informado'
        : true;
    const filtroProdutos = formFiltros.produtos
      ? item.produtos
          ?.toLowerCase()
          .includes(formFiltros.produtos.toLowerCase())
      : true;

    return filtroTipo && filtroStatus && filtroComponente && filtroProdutos;
  });

  const tableAquisicoes = dadosFiltrados.map((item) => {
    const componenteLabel =
      componenteAFoptions.find(
        (componente) => componente.value == item.componenteAf,
      )?.label || 'Não informado';
    const componenteBackgroundColor = getComponenteAfColor(componenteLabel);

    const componenteSigla = item.componenteAf
      ? // ? componenteAFoptions[item.componenteAF].label.slice(0, 1).toUpperCase()
        componenteLabel.slice(0, 1).toUpperCase()
      : '-';

    const tipoItem = item.produtos ? 'D' : 'K';
    const backgroundColor = getTipoItemColor(tipoItem);

    let statusBackgroundColor = '';
    const statusLabel =
      statusProaqOptions.find((status) => status.value == item.status)?.label ||
      'Não informado';

    if (statusLabel === 'Em Elaboração') {
      statusBackgroundColor = theme.colors.amarelogov;
    } else if (statusLabel === 'Em Execução') {
      statusBackgroundColor = theme.colors.verde;
    } else if (statusLabel === 'Finalizado') {
      statusBackgroundColor = theme.colors.cinzaEscuro;
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
    } else if (statusLabel === 'Encerrado') {
      statusBackgroundColor = theme.colors.cinzaEscuro;
    }

    return {
      id: item.id,
      tipo: item.tipo,
      status: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: 'white',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),
      componenteAf: (
        <div>
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: 'white',
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>{componenteLabel}</span>
        </div>
      ),
      produtos:
        typeof item.produtos === 'string' && item.produtos.length > 0 ? (
          <div
            style={{
              textAlign: 'left',
              justifySelf: 'flex-start',
            }}
          >
            <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
              {item.produtos
                .split(/, |; /)
                .map((produto: string, index: number) => (
                  <li key={index} style={{ marginBottom: '5px' }}>
                    <span
                      style={{
                        backgroundColor: backgroundColor,
                        borderRadius: '7px',
                        padding: '4px',
                        verticalAlign: 'center',
                        textAlign: 'center',
                        marginRight: '5px',
                        color: 'white',
                        display: 'inline-block',
                        minWidth: '30px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {tipoItem}
                    </span>
                    {produto}
                  </li>
                ))}
            </ul>
          </div>
        ) : (
          <span style={{ fontStyle: 'italic', color: '#888' }}>
            Não informado
          </span>
        ),
    };
  });

  const handleChangeFiltros = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const newValue = name === 'componenteAf' ? parseInt(value, 10) : value;

    setFormFiltros((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      tipo: '',
      status: '',
      componenteAf: 0,
      produtos: '',
    });
  };

  const handleExport = async () => {
    try {
      await exportData(
        dadosFiltrados,
        `listagem_aquisicoes_${formatDateToFile(new Date().toISOString())}.xlsx`,
        userID,
        'Listagem de Aquisições',
        'DAF',
        {
          componenteAF: componenteAFoptions,
        },
      );
    } catch (error) {
      console.error('Erro na exportação:', error);
    }
  };
  const offCanvasData = dadosFiltrados.map((item) => {
    const { backgroundColor: statusBackgroundColor, color: colorText } =
      getStatusColors(item.status);
    const componenteBackgroundColor = getComponenteAfColor(item.componenteAf);
    const componenteSigla = item.componenteAf.slice(0, 1).toUpperCase();
    return {
      id: item.id,
      tipoAquisicao: item.tipo,
      status: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            borderRadius: '10px',
            padding: '10px',
            color: colorText,
            display: 'inline-block',
            minWidth: '117px',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {item.status}
        </span>
      ),
      componenteAf: (
        <div style={{ justifyContent: 'left' }}>
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: 'white',
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>{item.componenteAf}</span>
        </div>
      ),
      denominacaoKit:
        typeof item.produtos === 'string' && item.produtos.length > 0 ? (
          <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
            {item.produtos
              .split(/, |; /)
              .map((produto: string, index: number) => (
                <li key={index} style={{ marginBottom: '5px' }}>
                  {produto}
                </li>
              ))}
          </ul>
        ) : (
          <span style={{ fontStyle: 'italic', color: '#888' }}>
            Não informado
          </span>
        ),
    };
  });
  const handleRowClick = (item: any) => {
    if (!item) return;
    const id = item.id;
    const tipo = item.tipoAquisicao ? item.tipoAquisicao : item.tipo;
    let path = '';
    switch (tipo) {
      case 'ARP':
        path = `/daf/proaq/arps/ficha/${id}/dadosgerais`;
        break;
      case 'Contrato':
        path = `/daf/proaq/contratos/ficha/${id}/dadosgerais`;
        break;
      case 'TED':
        path = `/daf/proaq/teds/ficha/${id}/dadosgerais`;
        break;
      case 'ACT':
        path = `/daf/proaq/acts/ficha/${id}/dadosgerais`;
        break;
      case 'Processo Licitatório':
        path = `/daf/proaq/processos/ficha/${id}/dadosgerais`;
        break;
      case 'Org. Inter.':
        path = `/daf/proaq/orginters/ficha/${id}/dadosgerais`;
        break;
      default:
        return;
    }
    navigate(path);
  };
  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="20%">
              <Select
                name="tipo"
                value={formFiltros.tipo}
                options={tiposAquisicaoUnicos}
                onChange={handleChangeFiltros}
                label="Tipo de Aquisição"
              />
            </CustomCol>
            <CustomCol width="20%">
              <Select
                name="status"
                value={formFiltros.status}
                options={statusUnicos}
                onChange={handleChangeFiltros}
                label="Status"
              />
            </CustomCol>
            <CustomCol width="20%">
              <Select
                name="componenteAf"
                value={formFiltros.componenteAf}
                options={componenteAFoptions}
                onChange={handleChangeFiltros}
                label="Comp. AF"
              />
            </CustomCol>
            <CustomCol width="40%">
              <Input
                name="produtos"
                label="Denominação/Kit"
                value={formFiltros.produtos}
                onChange={handleChangeFiltros}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersListagemAquisicoes}
          dataTable={tableAquisicoes}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasListagemAquisicoes}
          tituloCanvas="AQUISIÇÕES"
          onRowClick={handleRowClick}
          onAbrirOffCanvasClick={handleRowClick}
          resultRow={true}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes download onClickDownload={handleExport} />
      </BarraInferiorBotoes>
    </>
  );
};

export default ListagemAquisicoesIndex;
